import { Routes, Route } from 'react-router-dom';
import NonAuthLayout from '../Layout/NonAuthLayout';
import { publicRoutes } from './routes';
import { useEffect } from 'react';
import useUserStore from '../store/useUserStore';

const Index = () => {

  const setWindowInnerWidth = useUserStore(state => state.setWindowInnerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowInnerWidth(window.innerWidth);
    };

    handleResize(); 

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setWindowInnerWidth]);

  return (
    <Routes>
      <Route>
        {publicRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            exact
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
          />
        ))}
      </Route>
    </Routes>
  );
};

export default Index;
